// extracted by mini-css-extract-plugin
export default {"participantAvatar":"ParticipantsList-module__participantAvatar--W_DRV","participantLimitNotice":"ParticipantsList-module__participantLimitNotice--AzQx0"};